import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { getRootStore } from "@/stores/RootStore";
import { observer } from "mobx-react-lite";
import { canEditDictionaries } from "@/utils/permissions";
import { canDeleteFromDictionaries } from "@/utils/permissions";
import { message, Modal, Skeleton, Card, Button, Flex } from "antd";
import styles from "@/styles/ChargingStationPage.module.less";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import { ChargingStationForm } from "@/components/ChargingStationForm/ChargingStationForm";
export const ChargingStationPage = observer(() => {
    const navigate = useNavigate();
    const { stationId } = useParams();
    const { singleChargingStationStore: store, authStore: { userRole }, } = getRootStore();
    const { station, loading, modelSelectStore } = store;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        store.init(stationId);
        return () => {
            store.clearStationData();
        };
    }, [stationId]);
    const handleBack = () => {
        navigate("/charging-stations");
    };
    const handleSave = async (values) => {
        const isNewStation = !station;
        store.saveStation(values).then((savedStation) => {
            if (savedStation) {
                if (isNewStation) {
                    message.success("Зарядная станция успешно создана");
                    navigate(`/charging-stations/${savedStation.id}`);
                }
                else {
                    message.success("Зарядная станция успешно обновлена");
                }
            }
        });
    };
    const handleDeleteStation = () => {
        if (!station)
            return;
        Modal.confirm({
            title: "Удаление зарядной станции",
            content: "Вы уверены, что хотите удалить эту станцию?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: async () => {
                await store.deleteStation(station.id);
                message.success("Зарядная станция успешно удалена");
                handleBack();
            },
        });
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return (_jsxs(Flex, { vertical: true, gap: "large", className: styles.container, children: [_jsx("div", { className: styles.backButtonContainer, children: _jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: handleBack, type: "text", className: styles.backButton, children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443" }) }), _jsx(ChargingStationForm, { station: station, loading: loading, onSubmit: handleSave, onCancel: handleBack, disabled: !canEdit, extraButtons: _jsx(_Fragment, { children: canDelete && station && (_jsx(Button, { danger: true, icon: _jsx(DeleteOutlined, {}), onClick: handleDeleteStation, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u0430\u043D\u0446\u0438\u044E" })) }), selectStores: {
                    modelSelectStore,
                } })] }));
});
export default ChargingStationPage;
